import { Button, Stack } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { FlexColumn } from "components/core/Cards/styles";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "theme";
import NeoChip from "./NeoChip";
import { Icons, Ptag } from "components/core";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { formatToPascalCase } from "utlis/utils";

function CustomizedAccordion({ productType, userPlan, postFormat }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [endsFile, setEndsFile] = useState("");
  const [invoice, setInvoice] = useState("");
  const onClickHander = () => {
    if (postFormat[userPlan]) {
      setOpen((value) => !value);
    } else {
      console.log("not exist");
      redirecttion();
    }
  };
  useEffect(() => {
    const endsFile = postFormat && postFormat[userPlan]?.endorsment_file;
    const invoiceFile = postFormat && postFormat[userPlan]?.invoice_file;
    if(endsFile && invoiceFile) setOpen(true);
    setEndsFile(endsFile);
    setOpen(!!endsFile);
    setInvoice(invoiceFile);
  }, [postFormat]);
  const redirecttion = () => {
    navigate(`/${routes.UNIVERSAL_POLICY_ID_UPLOAD}`, {
      state: { postFormat, userPlan },
    });
  };
  return (
    <BoxStyle>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => onClickHander()}
      >
        <Ptag fontSize="18px" fontWeight="500">
          {formatToPascalCase(productType)}
        </Ptag>
        <Icons icon={open ? "chevron_down" : "chevron_right"} />
      </div>
      {open && (
        <div
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
          }}
        >
          <Stack direction="row" spacing={1}>
            <NeoChip label={endsFile} />
            <NeoChip label={invoice} />
          </Stack>
          <Button
            variant="outlined"
            startIcon={<FileUploadIcon />}
            onClick={() => redirecttion()}
            sx={{
              width: "300px",
              height: "54px",
              fontSize: "16px",
              marginTop: "3rem",
              textTransform: "none",
              color: `${colors.defaultFontColor}`,
              border: `1px solid ${colors.primaryColor}`,
              borderRadius: "10px",
              "&:focus": {
                outline: "none",
                boxShadow: "none",
                borderColor: `${colors.primaryColor}`,
              },
            }}
          >
            Upload Again
          </Button>
        </div>
      )}
    </BoxStyle>
  );
}

export default CustomizedAccordion;

const BoxStyle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: solid ${colors.primaryColor} 1px;
  border-radius: 6px;
`;
